<template>
  <div id="settings-app" class="rounded relative overflow-hidden body-module-height z-20">
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="h-full tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

      <!-- Product category -->
      <vs-tab icon-pack="feather" icon="icon-menu" :label="!isSmallerScreen ? $t('pages.settings.menu.productCategory') : ''" class="h-full">
        <div class="h-full md:ml-4 md:mt-0 mt-4 ml-0">
          <product-category />
        </div>
      </vs-tab>

      <!-- Announcements -->
      <vs-tab icon-pack="feather" icon="icon-volume-1" :label="!isSmallerScreen ? $t('pages.settings.menu.announcements') : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <announcements />
        </div>
      </vs-tab>

      <!-- Emails -->
      <vs-tab icon-pack="feather" icon="icon-mail" :label="!isSmallerScreen ? $t('pages.settings.menu.emails') : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          Configuração dos diferentes tipos de email que a plataforma envia, quando tem um evento
        </div>
      </vs-tab>

      <!-- Shipment -->
      <vs-tab icon-pack="feather" icon="icon-truck" :label="!isSmallerScreen ? $t('pages.settings.menu.shipment') : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          Tabela de costomização de envio... preço de motoboy...
        </div>
      </vs-tab>

      <!-- Shipment -->
      <vs-tab icon-pack="feather" icon="icon-printer" :label="!isSmallerScreen ? $t('pages.settings.menu.manufacturer') : ''" class="h-full">
        <div class="h-full md:ml-4 md:mt-0 mt-4 ml-0">
          <manufacture-settings />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import ProductCategory from './settings/ProductCategories'
import Announcements from './settings/Announcements'
import ManufactureSettings from './settings/ManufactureSettings';

export default {
  components: {
    ProductCategory,
    Announcements,
    ManufactureSettings
  },
  data () {
    return {
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
  #profile-tabs {
    .vs-tabs--content {
      padding: 0;
    }
}
</style>
